"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PortfolioColumnModel = /** @class */ (function () {
    function PortfolioColumnModel(columnType, fieldName, externalFunction, modulePath, componentSelector, dynamicColumnWidth, template$, columnHeaderNameKey, actionsOnly) {
        this._columnType = columnType;
        this._fieldName = fieldName;
        this._modulePath = modulePath;
        this._componentSelector = componentSelector;
        this._externalFunction = externalFunction;
        this._dynamicColumnWidth = dynamicColumnWidth;
        this._template$ = template$;
        this._columnHeaderNameKey = columnHeaderNameKey;
        this._actionsOnly = actionsOnly;
    }
    Object.defineProperty(PortfolioColumnModel.prototype, "columnType", {
        get: function () {
            return this._columnType;
        },
        set: function (value) {
            this._columnType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioColumnModel.prototype, "fieldName", {
        get: function () {
            return this._fieldName;
        },
        set: function (value) {
            this._fieldName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioColumnModel.prototype, "columnHeaderNameKey", {
        get: function () {
            return this._columnHeaderNameKey;
        },
        set: function (value) {
            this._columnHeaderNameKey = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioColumnModel.prototype, "modulePath", {
        get: function () {
            return this._modulePath;
        },
        set: function (value) {
            this._modulePath = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioColumnModel.prototype, "componentSelector", {
        get: function () {
            return this._componentSelector;
        },
        set: function (value) {
            this._componentSelector = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioColumnModel.prototype, "externalFunction", {
        get: function () {
            return this._externalFunction;
        },
        set: function (value) {
            this._externalFunction = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioColumnModel.prototype, "dynamicColumnWidth", {
        get: function () {
            return this._dynamicColumnWidth;
        },
        set: function (value) {
            this._dynamicColumnWidth = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioColumnModel.prototype, "template$", {
        get: function () {
            return this._template$;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioColumnModel.prototype, "actionsOnly", {
        get: function () {
            return this._actionsOnly;
        },
        set: function (value) {
            this._actionsOnly = value;
        },
        enumerable: true,
        configurable: true
    });
    return PortfolioColumnModel;
}());
exports.PortfolioColumnModel = PortfolioColumnModel;
//# sourceMappingURL=portfolio.column.model.js.map